import { render } from "./EmployeeViewServiceReport.vue?vue&type=template&id=2a404665"
import script from "./EmployeeViewServiceReport.vue?vue&type=script&lang=js"
export * from "./EmployeeViewServiceReport.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__